import React from "react";
import SituationImage from "../situation/SituationImage";

interface CoachingCampsIntroProps {
  imageUrl: string;
  isMobile: boolean;
  section?: string;
}

const CoachingCampsIntro = ({ imageUrl, isMobile, section = "coaching-camps-banner" }: CoachingCampsIntroProps) => {
  return (
    <>
      {isMobile ? (
        <div className="flex flex-col md:flex-row md:items-center md:space-x-8">
          <SituationImage 
            imageUrl={imageUrl} 
            isMobile={true} 
            section={section}
          />
        </div>
      ) : (
        <div className="flex flex-col items-center">
          <SituationImage 
            imageUrl={imageUrl} 
            isMobile={false} 
            section={section}
          />
        </div>
      )}
    </>
  );
};

export default CoachingCampsIntro;